import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Sort} from "@angular/material/sort";

@Component({
  selector: 'app-delete-all-confirm-dialog',
  templateUrl: './delete-all-customers-dialog.component.html',
  styleUrls: ['./delete-all-customers-dialog.component.scss']
})
export class DeleteAllCustomersDialogComponent implements OnInit {
  totalSuccess = 0;
  totalFailure = 0;
  dataSource: any[];
  constructor(
    public dialogRef: MatDialogRef<DeleteAllCustomersDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  checkEscKey = true;
  sortColumn = 'name';
  displayedColumns: string[] = ["name", "reason"];

  ngOnInit() {
    this.dataSource = this.data.dataRow.filter(data => data.status===0);
    this.totalSuccess = this.data.dataRow.filter(data => data.status===1).length;
    this.totalFailure = this.dataSource.length;
  }

  close() {
    this.dialogRef.close();
  }
  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }
}
